<div class="fullscreen-alert bg-{{data.color}}" (click)="dismiss()">
    <lib-button icon="close" (click)="dismiss()" color="none" size="small"></lib-button>
    <h1 class="fullscreen-alert-title" [style.fontSize]="data.fontSize || '24px'">{{data.title}}</h1>
</div>